export const CONNECT_UNREAD_CHANGED_EVENT = 'connect-unread-changed'
